/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** push-controller */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** push-controller pushAllUpgrade */
export async function pushAllUpgradeGet(options?: RequestOptions) {
  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/es/api/biz/push/all-user/upgrade`,
    method: 'get',
    ...options,
  });

  return result.data;
}

/** push-controller generatorFP */
export async function generatorFPGet(
  payload: {
    pipeType?: 'ios' | 'android' | 'pc' | 'mac' | 'web';
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultstring>({
    url: `/es/api/biz/push/fp`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** push-controller generatorFPV2 */
export async function generatorFPV2Get(
  payload: {
    pipeType?: 'ios' | 'android' | 'pc' | 'mac' | 'web';
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultPushFPResponse>({
    url: `/es/api/biz/push/fp/v2`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** push-controller refreshPipeId */
export async function refreshPipeIdGet(
  payload: {
    pipeId?: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultobject>({
    url: `/es/api/biz/push/pipe-id/refresh`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** push-controller removePipeId */
export async function removePipeIdGet(
  payload: {
    pipeId?: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultobject>({
    url: `/es/api/biz/push/pipe-id/remove`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** push-controller pushMessage */
export async function pushMessageGet(
  payload: {
    userId?: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/es/api/biz/push/push-message`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}
